import React from "react";
import MTASubwayBullet from "./MTASubwayBullet";

const AlertRow = ({ alert }) => {
  const engText = alert.alert.headerText?.translation?.find((t) => t.language == "en")?.text?.replace(/\n/g, ". ")
  
  // find line names in brackets and replace for line icon
  // e.g [F] to <img src="https://api.mta.info/lineIcons/F.svg" className="rounded-full w-10 inline px-1 mb-1"/>

  const separateText = engText?.split(/\[(.*?)\]/g)

  const replacedText = separateText?.map((t) => {
    if (t.length == 1 || t.length == 2) { 
      return <MTASubwayBullet route={t} size="sm" />
    } else {
      return t
    }
  })

  const alertStart = new Date(alert.alert.activePeriod[0].start * 1000)
  const alertSecondsAgo = Math.round((new Date().getTime() - alertStart.getTime()) / 1000)
  const alertMinutesAgo = Math.round(alertSecondsAgo / 60)
  const alertTimeString = alertMinutesAgo >= 60
    ? `${Math.floor(alertMinutesAgo / 60)}h ${alertMinutesAgo % 60}m ago`
    : `${alertMinutesAgo} minutes ago`
  const showAlert = alertMinutesAgo < 800

  return showAlert && (
      <div className="route-alert flex flex-row gap-4 items-center p-4 border-yellow bg-yellow-100 rounded-xl ">
        <span className="text-xl rounded-full font-medium text-white text-center w-8 h-8">⚠️</span>
        <span className="font-semibold text-xl text-yellow-800">{replacedText} ({alertTimeString})</span>
      </div>
  )
}

export default AlertRow;
